import React, { useState } from 'react';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import Hero from '../../components/Hero/Hero';
import products from '../../data/products';
import productsBanner from '../../assets/images/products/products-banner.png';
import './Products.css';

const Products = () => {
  const [expandedId, setExpandedId] = useState(null);

  const toggleExpand = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  return (
    <div className="products-page">
      <Hero
        title={<>Our <span className="highlight">Products</span></>}
        subtitle="Comprehensive range of industrial fasteners and mechanical parts to meet every manufacturing need."
        backgroundImage={productsBanner}
      />

      <section className="products section">
        <div className="container">
          <p className="section-subtitle">Product Catalog</p>
          <h2 className="section-title">What We <span className="highlight">Offer</span></h2>

          <div className="products__grid">
            {products.map((product) => (
              <div
                className={`product-card ${expandedId === product.id ? 'product-card--expanded' : ''}`}
                key={product.id}
              >
                <div className="product-card__image">
                  <img src={product.image} alt={product.name} />
                  <div className="product-card__number">
                    {String(product.id).padStart(2, '0')}
                  </div>
                </div>
                <div className="product-card__body">
                  <h3 className="product-card__title">{product.name}</h3>
                  <p className="product-card__desc">{product.description}</p>

                  {expandedId === product.id && (
                    <ul className="product-card__details">
                      {product.details.map((detail, idx) => (
                        <li key={idx}>{detail}</li>
                      ))}
                    </ul>
                  )}

                  <button
                    className="product-card__toggle"
                    onClick={() => toggleExpand(product.id)}
                  >
                    {expandedId === product.id ? (
                      <>Less Info <FaChevronUp /></>
                    ) : (
                      <>More Info <FaChevronDown /></>
                    )}
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="products__note">
            <p>
              <strong>Furthermore</strong> — At Tokyo Byokane Philippines, we are registered and
              qualified to supply tools, instruments, equipment, and other accessories for your
              needs in the area of manufacturing processes.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Products;
